import { IconProps } from "@/assets/CadwellIcons.tsx";

export function HamburgerIcon({size = 24, style, ...others}: IconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      style={{width: size, height: size, ...style}}
      {...others}
    >
      <path d="M2.3999 5.70005C2.3999 5.20299 2.80285 4.80005 3.2999 4.80005H20.6999C21.197 4.80005 21.5999 5.20299 21.5999 5.70005C21.5999 6.19711 21.197 6.60005 20.6999 6.60005H3.2999C2.80285 6.60005 2.3999 6.19711 2.3999 5.70005ZM2.3999 11.7C2.3999 11.203 2.80285 10.8 3.2999 10.8H20.6999C21.197 10.8 21.5999 11.203 21.5999 11.7C21.5999 12.1971 21.197 12.6 20.6999 12.6H3.2999C2.80285 12.6 2.3999 12.1971 2.3999 11.7ZM3.2999 16.8C2.80285 16.8 2.3999 17.203 2.3999 17.7C2.3999 18.1971 2.80285 18.6 3.2999 18.6H20.6999C21.197 18.6 21.5999 18.1971 21.5999 17.7C21.5999 17.203 21.197 16.8 20.6999 16.8H3.2999Z"
            fill="currentColor"/>
    </svg>
  );
}